import React from "react";
import Widget from "../../../../shared/components/features/widget/Widget";
import { useSelector } from "react-redux";
import pathRouts from "../../../../shared/enums/pathRoute";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import plusLearningWidgetImg from "../../../../assests/plusLearning/plusLearningWidgetImg.png";
import classes from "./PlusLearningWidget.module.css";

const PlusLearningWidget = () => {
    const { texts } = useSelector(state => state.translate);

    return (
        <Widget
            color="#F1799A"
            mainLink={`/${pathRouts.PLUSLEARNING}`}
            title={texts.plusLearning}
            icon={iconsList.plusLearning}
            className={classes.PlusLearningWidget}
        >
            <div className={classes.PlusLearningContent}>
                <img
                    src={plusLearningWidgetImg}
                    alt={texts.plusLearning}
                    className={classes.PlusLearningImg}
                />
                <div className={classes.PlusLearningText}>
                    {texts.plusLearningText}
                </div>
            </div>
        </Widget>
    );
};

export default PlusLearningWidget;